// src/Views/HomePage.js — Flasher long-scroll composition.
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Hero from './Hero';
import Throughline from './Throughline';
import BuildsPage from './BuildsPage';
import ProductsPage from './ProductsPage';
import WhoIAm from './WhoIAm';
import WorkWithMePage from './WorkWithMePage';
import ContactSection from './ContactSection';
import Footer from './Footer';

const HomePage = ({ scrollTo }) => {
  // Per-section routes (e.g. /builds, /products) mount HomePage with scrollTo
  // set to the matching anchor id; jump to it after the layout settles.
  useEffect(() => {
    if (!scrollTo) {
      window.scrollTo({ top: 0, behavior: 'auto' });
      return;
    }
    const id = setTimeout(() => {
      const el = document.getElementById(scrollTo);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 80);
    return () => clearTimeout(id);
  }, [scrollTo]);

  return (
    <>
      <Helmet>
        <title>Solomon Foshko | Design by Dialogue</title>
        <meta
          name="description"
          content="I build ideas into working systems. AI is my construction medium. Board games, civic tech, coaching platforms, games intelligence — same builder, same method, different worlds."
        />
      </Helmet>
      <Hero />
      <Throughline />
      <BuildsPage />
      <ProductsPage />
      <WhoIAm />
      <WorkWithMePage />
      <ContactSection />
      <Footer />
    </>
  );
};

export default HomePage;
